export default __webpack_public_path__ + "static/media/idcard.0a84f2eb.svg";